import keycloakService from '../../keycloak_service';

import { sinatraOrigin } from '../../config';

const postToApi = async (sinatraEndpoint = '', fetchOptions = {}) => fetch(`${sinatraOrigin}/${sinatraEndpoint}`, fetchOptions)

export const fetchAssayBaseline = ({
  pipelineID, 
  workspaceId, 
  start = null, 
  end = null, 
  limit = null, 
  next = null
}) => {
  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body: JSON.stringify({
      pipeline_name: pipelineID,
      workspace_id: workspaceId,
      start,
      end,
      limit,
      next,
    })
  };

  return postToApi('v1/api/assays/get_baseline', fetchOptions)
}

// Wrapper for SWR Fetch Function
export const swrAssayBaselineFetcher = (queryParams) => {
  const [pipelineID, workspaceId, limit] = queryParams;

  return fetchAssayBaseline({
    pipelineID, workspaceId, limit
  })
}

export default fetchAssayBaseline;
